import { DesignSystem } from "../design-system.js";
import { SimpleTable } from "./simple-table.js";
import { styles as SimpleTableStyles } from "./simple-table.styles.js";
/**
 * The Fabric Simple Table component definition.
 *
 * @public
 * @remarks
 * HTML Element: <fabric-simple-table>
 */
export const definition = SimpleTable.compose({
    name: `${DesignSystem.prefix}-simple-table`,
    styles: SimpleTableStyles,
    // Light DOM (no shadow root) is required because HTML table semantics don't accept
    // <slot> as a valid child element. The DOM children of <table> must be thead, tbody,
    // tfoot, etc. - not slots. This preserves native table accessibility and framework
    // compatibility while allowing us to apply Fluent and Fabric styling via CSS classes.
    shadowOptions: null
});
//# sourceMappingURL=simple-table.definition.js.map